import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperclip2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paperclip-2, attachment"><path d="M6.75 8.75V16C6.75 18.8995 9.10051 21.25 12 21.25C14.8995 21.25 17.25 18.8995 17.25 16V5.375C17.25 3.92525 16.0747 2.75 14.625 2.75C13.1753 2.75 12 3.92525 12 5.375V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconPaperclip2;
